<template>
  <v-tooltip location="bottom" content-class="rounded badge-popover">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        :href="`https://wvs2document.com${path}`"
        target="_blank"
        icon="$mdiBookOpenPageVariantOutline"
        class="rounded border manual-btn"
      ></v-btn>
    </template>
    <span>マニュアル</span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";

/** 画面右上に設置されているマニュアルボタンのコンポーネント */
export default defineComponent({
  name: "ManualButton",
  props: {
    /** 「https://wvs2document.com」以降のマニュアルURLパス */
    path: {
      type: String as PropType<string>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
a.manual-btn {
  width: 54px;
  height: 38px;
}
</style>
